module.exports = __webpack_public_path__ + "media/impala_k.784ef829.mp3";